export default __webpack_public_path__ + "static/media/register-illustration.dfe632c5.png";